<template>
  <section class="h_09">
    <div class="title_container">
      <div class="title f-section-title">
        <div>文字壁纸</div>
      </div>
      <div class="des f-section-sub-title">
        将你设置的汉字拆解、重构，以笔画的形态漂浮在屏幕里，尽显汉字之美
      </div>
    </div>
    <div class="video_container" v-ia>
      <div class="border_container_night">
        <m-video
          poster="@/v2/mobile/assets/video/poster/v_09.webp"
          src="@/v2/mobile/assets/video/v_9.mp4"
          muted
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          autoplay
          ref="video"
        ></m-video>
      </div>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs.video)"
      />
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    videoPlayByVisibleAreaH5(this.$refs.video)
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.h_09 {
  position: relative;
  .title {
    padding-top: 120px;
    display: flex;
    flex-direction: column;
    width: max-content;
    line-height: 1.4;
    color: #fff;
    margin: 0 24px;
  }
  .des {
    margin: 20px 24px;
    width: calc(100% - 48px);
    min-width: 330px;
  }
  .video_container {
    width: calc(100% - 48px);
    margin: 0 24px;
    video {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    .alive_replay {
      margin-left: 3px;
      margin-top: 22px;
      color: #3b82fc;
    }
  }
}
</style>
